import { render } from "./oper-record-detail.vue?vue&type=template&id=8ee381e4"
import script from "./oper-record-detail.vue?vue&type=script&lang=js"
export * from "./oper-record-detail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__